/**
 * Enum that defines all available Email template types.
 */
export enum EmailTemplateType {
  ClearanceCancelled = 'cancelledClearance',
  ClearanceDueSoon = 'dueSoonClearance',
  ClearanceModified = 'modifiedClearance',
  ClearanceOverdue = 'overdueClearance',
  ClearanceReminder = 'reminderClearance',
  ClearanceScheduled = 'scheduledClearance',
  FitTestCancelled = 'cancelledFitTest',
  FitTestDueSoon = 'dueSoonFitTest',
  FitTestFailed = 'failedFitTest',
  FitTestModified = 'modifiedFitTest',
  FitTestOverdue = 'overdueFitTest',
  FitTestPassed = 'passedFitTest',
  FitTestReminder = 'reminderFitTest',
  FitTestScheduled = 'scheduledFitTest',
  TrainingCancelled = 'cancelledTraining',
  TrainingDueSoon = 'dueSoonTraining',
  TrainingModified = 'modifiedTraining',
  TrainingOverdue = 'overdueTraining',
  TrainingReminder = 'reminderTraining',
  TrainingScheduled = 'scheduledTraining'
}
